import { useGetEntities } from '@abaninja/util-store';

import { getDocumentAttachments } from '../documents';

export const useDocumentAttachments = () => useGetEntities(getDocumentAttachments);
